import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from "@angular/core";
import { NgbActiveModal, NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import { Observable } from "rxjs";
import { DteEmitido } from "src/app/models/Dte/DteEmitido";
import { DteRecibido } from "src/app/models/Dte/DteRecibido";
import { FacturaExportacion } from "src/app/models/Dte/FacturaExportacion";
import { IDte } from "src/app/models/Dte/IDte";
import { RespuestaEstadoDte } from "src/app/models/Dte/RespuestaEstadoDte";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { EstadoSii } from "src/app/models/EstadoSii";
import { TipoDte } from "src/app/models/tipoDte";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { Page } from "src/app/shared/models/Page";
import { DteEmitidosService } from 'src/app/services/dte-emitidos.service';
import { DteFilter } from 'src/app/models/Dte/DteFilter';
import * as FileSaver from 'file-saver';
import Swal from 'sweetalert2';
import { TokenStorageService } from "src/app/services/token-storage.service";
import { PaykuTransactionEnt } from "src/app/models/Payku/PaykuTransactionEnt";
import { Response } from "src/app/shared/models/Response";
import { DteExportSummary } from "src/app/models/Dte/DteExportSummary";

type SummaryRow = { concepto: string; cantidad: string | number; isTotal?: boolean };

@Component({
	selector: "app-export-modal",
	templateUrl: "./export-modal.component.html",
	styleUrls: ["./export-modal.component.scss"],
})
export class ExportModalComponent implements OnInit {
	@Output() exportData = new EventEmitter<boolean>();
	@ViewChild("summaryStepModal") summaryStepModal: TemplateRef<any>;
	@Input() locale: any;
	@Input() filter: any;
	@Input() encabezados: any;
	@Input() type: number;
	@Input() getDataFunction: (filter: any) => Observable<any>;
	@Input() getPagedDataFunction: (filter: any, totalEments: number) => Observable<any>;
	@Input() getSummaryFunction: (filter: DteFilter) => Observable<Response<DteExportSummary>>;
	@Input() getZipDataFunction: (request: any) => Observable<Blob>;
	@Input() useGridFilters: boolean = false;
	@Input() totalItems: number;
	validDate: boolean = true;
	public exportType: string = 'excel';
	public empresasSource: Emisor[];
	public tipoDteSource: TipoDte[];
	public isSuperAdmin: boolean = this.tokenService.getUser().superAdmin;
	private currentUsuarioId = this.tokenService.getUser().id;
	public dateExportacion: any = { startDate: null, endDate: null };
	public todayString = moment();
	public minDate: moment.Moment;
	public maxDate: moment.Moment = moment().endOf('day');
	public loadingSummary: boolean = false;
	public summaryError: string = "";
	public exportSummary: DteExportSummary;
	public summaryRows: SummaryRow[] = [];
	private summaryModalRef: NgbModalRef;
	private summaryFilterSnapshot: DteFilter | null = null;

	constructor(
		public activeModal: NgbActiveModal,
		public utilities: UtilitiesService,
		private datePipe: DatePipe,
		private localStorage: LocalStorageService,
		private dteEmitidosService: DteEmitidosService,
		private tokenService: TokenStorageService,
		private modalService: NgbModal
	) {}

	ngOnInit(): void {
		this.locale.format = "DD/MM/YYYY";

		if (this.useGridFilters) {
			this.minDate = moment().subtract(2, 'years').startOf('day');
		} else {
			// Para PayKu (tipo 999) el limite es 1 ano
			if (this.type === 999) {
				this.minDate = moment().subtract(1, 'year').startOf('day');
			} else if (this.isSuperAdmin) {
				this.minDate = moment().subtract(2, 'years').startOf('day');
			} else {
				this.minDate = moment().subtract(6, 'months').startOf('day');
			}
			this.dateExportacion.startDate = moment().startOf("day");
			this.dateExportacion.endDate = moment().startOf("day");
		}

		this.empresasSource = JSON.parse(this.localStorage.getEmisores()) as Emisor[];
		this.tipoDteSource = JSON.parse(this.localStorage.getDteTypes()) as TipoDte[];
	}

	detectExportChangeDate(event) {
		this.validDate = true;
		if (event.startDate != null && event.endDate != null) {
		  this.dateExportacion = event;
		  return;
		}
		if (event.target && event.target.value) {
		  const typedValue = event.target.value.trim();
	
		  if (typedValue.includes('-')) {
			const parts = typedValue.split('-').map(p => p.trim());
			if (parts.length === 2) {
			  const startString = parts[0];
			  const endString = parts[1];
			  const startIsValid = moment(startString, this.locale.format, true).isValid();
			  const endIsValid   = moment(endString, this.locale.format, true).isValid();
			  this.validDate = startIsValid && endIsValid;
	  
			  if (this.validDate) {
				this.dateExportacion = {
				  startDate: moment(startString, this.locale.format),
				  endDate:   moment(endString, this.locale.format),
				};
			  }
			} else {
			  this.validDate = false;
			}
		  } else {
			const singleIsValid = moment(typedValue, this.locale.format, true).isValid();
			this.validDate = singleIsValid;
			if (this.validDate) {
			  const date = moment(typedValue, this.locale.format);
			  this.dateExportacion = {
				startDate: date,
				endDate:   date, 
			  };
			}
		  }
		}
	  }

	private showWarning(message: string, confirmButtonText: string = "Si, exportar"): Promise<any> {
		return Swal.fire({
			title: "Advertencia",
			text: message,
			icon: "warning",
			showCancelButton: true,
			confirmButtonColor: "#3085d6",
			cancelButtonColor: "#d33",
			confirmButtonText,
			cancelButtonText: "Cancelar"
		});
	}

	private getGridRangeValidation(): { valid: boolean; message?: string } {
		const fechaDesde = moment(this.filter?.fechaDesde);
		const fechaHasta = moment(this.filter?.fechaHasta);

		if (!fechaDesde.isValid() || !fechaHasta.isValid()) {
			return { valid: false, message: "Debe aplicar un rango de fechas valido en el listado para exportar." };
		}

		if (fechaHasta.isBefore(fechaDesde, "day")) {
			return { valid: false, message: "El rango de fechas es invalido (fechaHasta < fechaDesde)." };
		}

		if (fechaHasta.isAfter(fechaDesde.clone().add(2, "years"), "day")) {
			return { valid: false, message: "El rango maximo permitido para exportar es de 2 años." };
		}

		return { valid: true };
	}

	private formatSummaryDate(dateValue: string): string {
		const dateText = String(dateValue || "");
		const datePart = dateText.match(/^(\d{4}-\d{2}-\d{2})/)?.[1];
		const date = datePart ? moment(datePart, "YYYY-MM-DD", true) : moment(dateValue);
		return date.isValid() ? date.format("DD/MM/YYYY") : "-";
	}

	private buildSummaryRows(summary: DteExportSummary): SummaryRow[] {
		if (!summary) {
			return [];
		}

		const rows: SummaryRow[] = [
			{
				concepto: "Rango de fecha",
				cantidad: `${this.formatSummaryDate(summary.fechaDesde)} - ${this.formatSummaryDate(summary.fechaHasta)}`
			}
		];

		if (summary.importadosSii > 0) {
			rows.push({ concepto: "Importados SII", cantidad: summary.importadosSii });
		}
		if (summary.anulados > 0) {
			rows.push({ concepto: "Anulados", cantidad: summary.anulados });
		}
		if (summary.reutilizados > 0) {
			rows.push({ concepto: "Dados de baja / reutilizados", cantidad: summary.reutilizados });
		}

		(summary.estadosSii || [])
			.filter((estado) => estado.cantidad > 0)
			.forEach((estado) => rows.push({ concepto: estado.descripcion || estado.codigo, cantidad: estado.cantidad }));

		(summary.tiposDte || [])
			.filter((tipo) => tipo.cantidad > 0)
			.forEach((tipo) => rows.push({ concepto: tipo.descripcion || tipo.codigo, cantidad: tipo.cantidad }));

		if (summary.totalRegistros > 0) {
			rows.push({ concepto: "Registros", cantidad: summary.totalRegistros, isTotal: true });
		}

		return rows;
	}

	/**
	 * Construye una copia profunda del filtro tomado de la grilla, con el
	 * `fileType` actual aplicado encima. La idea es que el preview y la
	 * exportacion trabajen sobre el MISMO payload aunque el componente
	 * padre siga mutando su filtro (paginacion, sort, etc.) mientras el
	 * modal esta abierto.
	 */
	private buildGridFilterSnapshot(): DteFilter {
		const snapshot = { ...this.filter, fileType: this.exportType } as DteFilter;

		// Los siguientes campos llegan como arrays (multi-select del search
		// bar). Hago una copia independiente de cada uno para que mutaciones
		// posteriores en la grilla no afecten al payload del modal.
		snapshot.tipoDteId = this.cloneFilterArray(snapshot.tipoDteId);
		snapshot.sucursalId = this.cloneFilterArray(snapshot.sucursalId);
		snapshot.estadoSii = this.cloneFilterArray(snapshot.estadoSii);
		snapshot.estadoAcuse = this.cloneFilterArray(snapshot.estadoAcuse);

		return snapshot;
	}

	/**
	 * Devuelve una copia del array recibido o el valor original tal cual si
	 * no es un array (mantiene el contrato del DteFilter, donde los campos
	 * multi pueden venir como string/number o como lista).
	 */
	private cloneFilterArray<T>(value: T): T {
		if (Array.isArray(value)) {
			return [...value] as unknown as T;
		}
		return value;
	}

	private getZipData(request: any): Observable<Blob> {
		return this.getZipDataFunction
			? this.getZipDataFunction(request)
			: this.dteEmitidosService.getZip(request);
	}

	private getEstadoSiiDescripcion(row: DteEmitido): string {
		if (row.estadoSiiDescripcion) {
			return row.estadoSiiDescripcion;
		}

		const estadosSii = JSON.parse(this.localStorage.getEstadosSii() || "[]") as EstadoSii[];
		const estado = estadosSii.find((item) => item.estadoId === row.estadoSii);
		return estado?.descripcion || "";
	}

	loadExportSummary(onLoaded?: () => void) {
		if (!this.useGridFilters || !this.getSummaryFunction) {
			return;
		}

		const dateValidation = this.getGridRangeValidation();
		if (!dateValidation.valid) {
			this.summaryError = dateValidation.message;
			this.exportSummary = null;
			this.summaryRows = [];
			this.summaryFilterSnapshot = null;
			return;
		}

		this.loadingSummary = true;
		this.summaryError = "";
		const filterWithFileType = this.buildGridFilterSnapshot();
		this.getSummaryFunction(filterWithFileType).subscribe({
			next: (response) => {
				this.exportSummary = response?.data;
				this.summaryRows = this.buildSummaryRows(this.exportSummary);
				this.summaryFilterSnapshot = filterWithFileType;
				this.loadingSummary = false;
				if (onLoaded) {
					onLoaded();
				}
			},
			error: (error) => {
				this.loadingSummary = false;
				this.exportSummary = null;
				this.summaryRows = [];
				this.summaryFilterSnapshot = null;
				this.summaryError = this.utilities.setErrorMessageFromArray(error?.error) || "No fue posible obtener el resumen de exportacion.";
			}
		});
	}

	onExportTypeChange() {
		if (this.useGridFilters && this.summaryModalRef) {
			this.loadExportSummary();
		}
	}

	openSummaryModal() {
		if (!this.useGridFilters || this.loadingSummary || this.summaryModalRef) {
			return;
		}

		const dateValidation = this.getGridRangeValidation();
		if (!dateValidation.valid) {
			Swal.fire({
				icon: "error",
				title: "Rango invalido",
				text: dateValidation.message
			});
			return;
		}

		this.loadExportSummary(() => {
			if (this.summaryModalRef) {
				return;
			}
			this.summaryModalRef = this.modalService.open(this.summaryStepModal, {
				size: "lg",
				centered: true,
				backdrop: true
			});
			this.summaryModalRef.result.finally(() => {
				this.summaryModalRef = null;
			});
		});
	}

	closeSummaryModal(modal?: any) {
		if (modal) {
			modal.dismiss("cancel");
			return;
		}

		if (this.summaryModalRef) {
			this.summaryModalRef.dismiss("cancel");
		}
	}

	canConfirmGridExport(): boolean {
		if (!this.useGridFilters || this.loadingSummary) {
			return false;
		}

		const dateValidation = this.getGridRangeValidation();
		if (!dateValidation.valid) {
			return false;
		}

		return (this.exportSummary?.totalRegistros || 0) > 0;
	}

	private exportExcelDataByType(elements: any[]) {
		elements.forEach((row) => {
			this.setEmisorToElement(row);
			this.setTipoDteToElement(row);
		});

		if (this.type == 33) {
			this.exportExcelData33(elements);
		} else if (this.type == 110) {
			this.exportExcelData110(elements);
		} else if (this.type == 52) {
			this.exportExcelData_52(elements);
		} else if (this.type == 46) {
			this.exportExcelData_46(elements);
		} else if (this.type == -1) {
			this.exportExcelData_Recibidos(elements);
		} else if (this.type == 999) {
			this.exportExcelDataPayku(elements);
		}
	}

	onSubmitWithGridFilters() {
		const dateValidation = this.getGridRangeValidation();
		if (!dateValidation.valid) {
			Swal.fire({
				icon: "error",
				title: "Rango invalido",
				text: dateValidation.message
			});
			return;
		}

		if (!this.exportSummary) {
			this.loadExportSummary();
			return;
		}

		if ((this.exportSummary.totalRegistros || 0) <= 0) {
			Swal.fire({
				icon: "info",
				title: "Sin resultados",
				text: "No hay documentos para exportar con los filtros actuales."
			});
			return;
		}

		const mostrarMensajeExito = () => {
			Swal.fire({
				icon: "success",
				title: "Exportacion de documentos",
				text: "Los documentos se han exportado correctamente",
			}).then(() => {
				this.closeModal();
			});
		};

		const exportFilter = this.summaryFilterSnapshot ? { ...this.summaryFilterSnapshot } : this.buildGridFilterSnapshot();

		if (this.exportType === "xml") {
			const dteIds = this.exportSummary?.dteIds || [];
			if (!dteIds.length) {
				Swal.fire({
					icon: "info",
					title: "Sin documentos XML",
					text: "No hay documentos con XML disponible para exportar con los filtros actuales."
				});
				this.exportData.emit(false);
				return;
			}

			this.exportData.emit(true);
			const request = { dteIds, fileType: "xml", EmisorId: exportFilter.emisorId };
			this.getZipData(request).subscribe({
				next: (blobZip) => {
					const dateOfDownLoad = moment().format("DDMMYYYY");
					const fileName = `documentos_${dateOfDownLoad}_${this.exportType}.zip`;
					FileSaver.saveAs(blobZip, fileName);
					this.exportData.emit(false);
					mostrarMensajeExito();
				},
				error: (error) => {
					console.error("Error al exportar XML:", error);
					this.exportData.emit(false);
				}
			});
			return;
		}

		if (this.getDataFunction != undefined) {
			this.exportData.emit(true);
			this.getDataFunction(exportFilter).subscribe(
				(result) => {
					const elements = result;
					this.exportExcelDataByType(elements);
					this.exportData.emit(false);
					mostrarMensajeExito();
				},
				(error) => {
					this.exportData.emit(false);
					console.error("Error al exportar:", error);
				}
			);
		}
	}

	onSubmit() {
		if (this.useGridFilters) {
			this.openSummaryModal();
			return;
		}

		if (this.validDate && this.dateExportacion.startDate && this.dateExportacion.endDate) {
			const rangoMeses = this.dateExportacion.endDate.diff(this.dateExportacion.startDate, 'months');
			let limiteMaximoMeses: number;
			let mensajeLimite: string;

			// Para PayKu (tipo 999) el limite es 1 ano (12 meses)
			if (this.type === 999) {
				limiteMaximoMeses = 12;
				mensajeLimite = '1 año';
			} else {
				limiteMaximoMeses = this.isSuperAdmin ? 24 : 6;
				mensajeLimite = this.isSuperAdmin ? '24 meses (2 años)' : '6 meses';
			}

			if (rangoMeses > limiteMaximoMeses) {
				Swal.fire({
					icon: 'error',
					title: 'Rango Excesivo',
					html: `Puede exportar en un rango de ${mensajeLimite}.`,
				});
				return;
			}

			this.filter.fechaDesde = this.dateExportacion.startDate.format("YYYY-MM-DD");
			this.filter.fechaHasta = this.dateExportacion.endDate.format("YYYY-MM-DD");
			const mostrarMensajeExito = () => {
				Swal.fire({
					icon: 'success',
					title: 'Exportacion de documentos',
					text: 'Los documentos se han exportado correctamente',
				}).then(() => {
					this.closeModal();
				});
			};

			if (this.exportType === 'pdf' || this.exportType === 'xml') {
				this.showWarning('La exportacion de los documentos puede tardar unos minutos. Desea continuar con la exportacion?')
				.then((result) => {
					if (result.isConfirmed) {
						this.exportData.emit(true);
						const request = {fromDate: this.filter.fechaDesde,toDate: this.filter.fechaHasta,fileType: this.exportType, EmisorId: this.filter.emisorId};
						this.getZipData(request).subscribe({
							next: (blobZip) => {
								const dateOfDownLoad = moment().format('DDMMYYYY');
								const fileName = `documentos_${dateOfDownLoad}_${this.exportType}.zip`;
								FileSaver.saveAs(blobZip, fileName);
								this.exportData.emit(false);
								mostrarMensajeExito();
							},
							error: (error) => {
								console.error('Error al exportar PDF/XML:', error);
								this.exportData.emit(false);
							}
						});
					} else {
						this.exportData.emit(false);
					}
				});
			}
			else if (this.getDataFunction != undefined) {
				this.showWarning('La exportacion de los documentos puede tardar unos minutos. Desea continuar con la exportacion?')
				.then((result) => {
					if (result.isConfirmed) {
						this.exportData.emit(true);
						this.getDataFunction(this.filter).subscribe(
							(result) => {
								const elements = result;
								this.exportExcelDataByType(elements);
								this.exportData.emit(false);
								mostrarMensajeExito();
							},
							(error) => {
								this.exportData.emit(false);
								console.error("Error al exportar:", error);
							}
						);
					} else {
						this.exportData.emit(false);
					}
				});
			}

			else if (this.getPagedDataFunction != undefined) {
				this.showWarning('La exportacion de los documentos puede tardar unos minutos. Desea continuar con la exportacion?')
				.then((result) => {
					if (result.isConfirmed) {
						this.exportData.emit(true);
						this.getPagedDataFunction(this.filter, this.totalItems).subscribe(
							(result) => {
								const elements = result.data;
								this.exportExcelDataByType(elements);
								this.exportData.emit(false);
								mostrarMensajeExito();
							},
							(error) => {
								this.exportData.emit(false);
								console.error("Error al exportar:", error);
							}
						);
					} else {
						this.exportData.emit(false);
					}
				});
			}
		}
	}

	setEmisorToElement(row: IDte) {
		let empresaAsociada = this.empresasSource.find((Emisor) => Emisor.emisorId == row.emisorId);
		row.emisorAsociado = empresaAsociada;
	}
	setTipoDteToElement(row: IDte) {
		if (row.tipoDteId) {
			let tipoDteAsociado = this.tipoDteSource.find((tipo) => tipo.tipoDteId == row.tipoDteId);
			row.nombreTipoDte = tipoDteAsociado.abreviacion;
		}
		else if(row.codigoTipoDte){
			let tipoDteAsociado = this.tipoDteSource.find((tipo) => tipo.codigosii == row.codigoTipoDte);
			row.nombreTipoDte = tipoDteAsociado.abreviacion;
		}
	}

	private getOrigenDte(row: DteEmitido): string {
		if (row.importado && row.formaPago !== "Importado") {
		  return "Importado SII";
		} else if (row.importado && row.formaPago === "Importado") {
		  return "Importado Sistema";
		} else {
		  return "SimpleFactura";
		}
	  }
	private getOrigenDteExportacion(row: FacturaExportacion): string {
		if (row.importacionMasivaId && row.formaPago !== "Importado") {
		  return "Importado SII";
		} else if (row.importacionMasivaId && row.formaPago === "Importado") {
		  return "Importado Sistema";
		} else {
		  return "SimpleFactura";
		}
	  }

	
	exportExcelData_Recibidos(arrayToExport: Array<DteRecibido>): void {
//		let RespuestasEstadoAcuseDte = JSON.parse(this.localStorage.getRespuestaEstadoDte()) as RespuestaEstadoDte[];

		let arregloExportar = [];
		arrayToExport.forEach((row) => {			
			let elementToExport = {};
			elementToExport["Tipo DTE"] = row.nombreTipoDte;
			elementToExport["Folio"] = row.folio;
			elementToExport["Emisor"] = row.emisorAsociado.razonSocial;
			elementToExport["Rut Proveedor"] = row.rutProveedorDv;
			elementToExport["Razon Social Proveedor"] = row.razonSocialProveedor;
			elementToExport["Fecha de Emision"] = this.datePipe.transform(row.fechaEmision, "dd/MM/yyyy");
			elementToExport["Fecha de Recepcion"] = this.datePipe.transform(row.fechaRecepcionSii, "dd/MM/yyyy");
			elementToExport["Fecha de Ultimo Procesamiento"] = this.datePipe.transform(row.fechaUltimoProcesamiento, "dd/MM/yyyy");
			elementToExport["Fecha de Vencimiento de Dte"] = this.datePipe.transform(row.fechaVencimiento, "dd/MM/yyyy");
			elementToExport["Fecha de Vencimiento de Acuse"] = this.datePipe.transform(row.fechaVencimientoAcuse, "dd/MM/yyyy");
			elementToExport["Neto"] = row.neto;
			elementToExport["IVA"] = row.iva;
			elementToExport["Exento"] = row.exento;
			elementToExport["Total"] = row.total;
			elementToExport["PDF LINK"] = row.pdfUrl;
			elementToExport["LINK_TEXT"] = row.pdfUrl ? 'Ver PDF' : 'Sin PDF';
			elementToExport["URL"] = row.pdfUrl ? row.pdfUrl : "Documento no disponible - No recibido en correo";
			arregloExportar.push(elementToExport);
		});
		this.utilities.exportAsExcelFile(arregloExportar, "Dte_recibidos");
	}

	//Factura de compra
	exportExcelData_46(arrayToExport: Array<DteEmitido>): void {
		let arregloExportar = [];
		arrayToExport.forEach((row) => {
			let elementToExport = {};
			elementToExport["Origen"] = this.getOrigenDte(row);
			elementToExport["Tipo DTE"] = row.nombreTipoDte;
			elementToExport["Folio"] = row.folio;
			elementToExport["Emisor"] = row.emisorAsociado.razonSocial;
			elementToExport["Rut Proveedor"] = row.rutReceptor;
			elementToExport["Razon Social Proveedor"] = row.razonSocial;
			elementToExport["Fecha de Emision"] = this.datePipe.transform(row.fecha, "dd/MM/yyyy");
			if (row.codigoTipoDte === 61) {
				elementToExport["Monto"] = Number(row.total * -1);
			} else {
				elementToExport["Monto"] = row.total;
			}
			arregloExportar.push(elementToExport);
		});
		this.utilities.exportAsExcelFile(arregloExportar, "Dte_emitidos");
	}

	//guia de despacho
	exportExcelData_52(arrayToExport: Array<DteEmitido>): void {
		let arregloExportar = [];
		arrayToExport.forEach((row) => {
			let elementToExport = {};
			elementToExport["Origen"] = this.getOrigenDte(row);
			elementToExport["Tipo DTE"] = row.nombreTipoDte;
			elementToExport["Folio"] = row.folio;
			elementToExport["Emisor"] = row.emisorAsociado.razonSocial;
			elementToExport["Rut Cliente"] = row.rutReceptor;
			elementToExport["Razon Social Cliente"] = row.razonSocial;
			elementToExport["Fecha de Emision"] = this.datePipe.transform(row.fecha, "dd/MM/yyyy");
			if (row.codigoTipoDte === 61) {
				elementToExport["Monto"] = Number(row.total * -1);
			} else {
				elementToExport["Monto"] = row.total;
			}
			arregloExportar.push(elementToExport);
		});
		this.utilities.exportAsExcelFile(arregloExportar, "Dte_emitidos");
	}

	exportExcelData110(arrayToExport: Array<FacturaExportacion>): void {
		let arregloExportar = [];
		arrayToExport.forEach((row) => {
			let elementToExport = {};
			elementToExport["Tipo DTE"] = row.nombreTipoDte;
			elementToExport["Folio"] = row.folio;
			elementToExport["Emisor"] = row.emisorAsociado.razonSocial;
			elementToExport["Rut Cliente"] = row.rutReceptor;
			elementToExport["Razon Social Cliente"] = row.razonSocial;
			elementToExport["Fecha de Emision"] = this.datePipe.transform(row.fecha, "dd/MM/yyyy");
			elementToExport["Pais"] = row.territorioDesembarque;
			elementToExport["Puerto Embarque"] = row.nombrePuertoEmbarque;
			elementToExport["Puerto Desembarque"] = row.nombrePuertoDestino;
			elementToExport["Clausula"] = row.clausulaVentaGlosa;
			elementToExport["Modalidad Venta"] = row.modalidadVentaGlosa;
			elementToExport["Moneda"] = row.tipoMoneda;
			elementToExport["Seguro"] = row.seguro;
			elementToExport["Flete"] = row.flete;
			elementToExport["Bienes"] = row.totalValorBienes;
			elementToExport["Monto Total Divisa"] = row.seguro + row.flete + row.totalValorBienes;
			elementToExport["Tipo de Cambio"] = row.tipoCambio;
			elementToExport["Monto Clp"] = row.montoClp;
			elementToExport["Origen"] = this.getOrigenDteExportacion(row);
			arregloExportar.push(elementToExport);
		});
		this.utilities.exportAsExcelFile(arregloExportar, "Dte_emitidos");
	}

	exportExcelData33(arrayToExport: Array<DteEmitido>): void {
		const referenceCount = arrayToExport.reduce(
			(maximum, row) => Math.max(maximum, row.listaReferenciasDteEmitido?.length || 0), 0
		);
		const arregloExportar = arrayToExport.map((row) => {
			let pdfLink = "";
			let linkText = "";
			let urlString = "";
			if (row.pdfUrl) {
				pdfLink = row.pdfUrl;
				linkText = "Ver PDF";
				urlString = row.pdfUrl;
			} else if (row.generatePDFUrl) {
				pdfLink = row.generatePDFUrl;
				linkText = "Generar PDF";
				urlString = "Documento no disponible";
			} else {
				pdfLink = "";
				linkText = "Documento no disponible";
			}
			const elementToExport: any = {
				"Tipo DTE": row.nombreTipoDte,
				Folio: row.folio,
				Emisor: row.emisorAsociado?.razonSocial || "",
				"Rut Cliente": row.rutReceptorDv,
				"Razon Social Cliente": row.razonSocial,
				"Fecha de Emision": this.datePipe.transform(row.fecha, "dd/MM/yyyy"),
				"Hora de Emision": this.datePipe.transform(row.fechaCreacion, "HH:mm:ss"),
				EstadoSII: this.getEstadoSiiDescripcion(row),
				Neto: row.neto,
				Iva: row.iva,
				Exento: row.exento,
				Impuesto: row.impuestos,
				Total: row.total,
				Origen: this.getOrigenDte(row),
				"PDF LINK": pdfLink,
				"LINK_TEXT": linkText,
				"URL": urlString
			};

			for (let index = 0; index < referenceCount; index++) {
				const reference = row.listaReferenciasDteEmitido?.[index];
				const prefix = `Referencia ${index + 1}`;
				elementToExport[`${prefix} - Tipo`] = reference?.codigoTipoDteReferencia ?? "";
				elementToExport[`${prefix} - Folio`] = String(reference?.folioReferencia ?? "");
				elementToExport[`${prefix} - Fecha`] = this.formatReferenceDate(reference?.fechaDteReferenciado);
				elementToExport[`${prefix} - Razón`] = reference?.razonReferencia ?? "";
			}

			return elementToExport;
		});

		this.utilities.exportAsExcelFile(arregloExportar, "Dte_emitidos");
	}

	private formatReferenceDate(dateValue: Date | string): string {
		if (!dateValue) {
			return "";
		}

		const datePart = String(dateValue).match(/^(\d{4}-\d{2}-\d{2})/)?.[1];
		const date = datePart ? moment(datePart, "YYYY-MM-DD", true) : moment(dateValue);
		const isMissingDate = date.year() === 1 && date.month() === 0 && date.date() === 1;
		return date.isValid() && !isMissingDate ? date.format("DD/MM/YYYY") : "";
	}

	exportExcelDataPayku(arrayToExport: Array<PaykuTransactionEnt>): void {
		const encabezados = [
			"Fecha", 
			"Hora", 
			"Monto facturado", 
			"Monto a recibir", 
			"Estado", 
			"Tipo", 
			"Receptor RUT",
			"Receptor Razon Social",
			"DTE Folio"
		];

		const arregloExportar = arrayToExport.map((row) => {
			return {
				"Fecha": this.datePipe.transform(row.fecha, "dd/MM/yyyy"),
				"Hora": this.datePipe.transform(row.fecha, "HH:mm:ss"),
				"Monto facturado": row.monto,
                "Bruto cobrado": row.montoBruto,
                "Neto estimado": row.montoNetoEstimado,
                "Neto informado por Payku": row.montoLiquidadoInformado ?? "Sin dato",
                "Fuente del importe": row.fuenteImporte || "",
                "Liquidación sin importe": row.liquidacionSinImporte ? "Sí" : "No",
                "Devuelto confirmado": row.montoDevuelto,
                "Devolución pendiente": row.montoDevolucionPendiente,
                "Remanente del pago": row.remanente,
                "Devolución por revisar": row.devolucionRequiereRevision ? "Sí" : "No",
                "Monto a recibir": row.liquidacionSinImporte ? "Sin dato" : row.montoNeto,
				"Estado": row.estado,
				"Tipo": row.tipo || "",
				"Receptor RUT": row.receptorRut || "",
				"Receptor Razon Social": row.receptorRazonSocial || "",
				"DTE Folio": row.dteFolio || ""
			};
		});

		this.utilities.exportAsExcelFile(arregloExportar, "Transacciones_PayKu");
	}

	

	closeModal() {
		if (this.summaryModalRef) {
			this.summaryModalRef.close();
			this.summaryModalRef = null;
		}
		this.activeModal.dismiss("Modal Closed");
	}
}
